import React from 'react'
import { useSelector } from 'react-redux'
const Layout = ({children}) => {
  const isAuthorized = useSelector((state) => state.auth.authenticated);
  return (
    <>
        {isAuthorized && children}
    </>
  )
}

export default Layout